<template>
  <div class="nx-page">
    <!-- Sheet dizayni uchun global CSS (preview va print bir xil bo'lsin) -->
    <div v-html="styleTag" style="display:none"></div>

    <!-- TOOLBAR (chop etishda yashiriladi) -->
    <div class="nx-toolbar no-print">
      <div class="nx-tool-left">
        <button class="nx-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
        <h2 class="nx-title"><b-icon icon="file-earmark-pdf-fill" class="mr-2"></b-icon>Narxnoma</h2>
      </div>

      <div class="nx-filters">
        <div class="nx-f"><label>Boshlanish</label><input type="date" v-model="date1" @change="fetch"></div>
        <div class="nx-f"><label>Tugash</label><input type="date" v-model="date2" @change="fetch"></div>
        <div class="nx-f nx-grow">
          <label>Brend</label>
          <v-select :options="brandList" v-model="brand_id" :reduce="b => b.id" label="name" placeholder="Barchasi" @input="fetch" />
        </div>
      </div>

      <div class="nx-actions">
        <button class="nx-btn nx-refresh" @click="fetch" :disabled="loading" title="Yangilash">
          <b-icon :icon="loading ? 'arrow-repeat' : 'arrow-repeat'" :class="{ spin: loading }"></b-icon>
        </button>
        <button class="nx-btn nx-optom" :disabled="loading || !items.length" @click="printPdf('optom')">
          <b-icon icon="printer-fill"></b-icon> Optom narx (PDF)
        </button>
        <button class="nx-btn nx-chakana" :disabled="loading || !items.length" @click="printPdf('chakana')">
          <b-icon icon="printer-fill"></b-icon> Chakana narx (PDF)
        </button>
      </div>
    </div>

    <!-- Rejim ko'rsatkichi (preview qaysi narxda) -->
    <div class="nx-mode-bar no-print">
      <span>Ko'rinish:</span>
      <button :class="['nx-mode', { active: priceMode === 'optom' }]" @click="priceMode = 'optom'">Optom</button>
      <button :class="['nx-mode', { active: priceMode === 'chakana' }]" @click="priceMode = 'chakana'">Chakana</button>
      <span class="nx-sep">|</span>
      <span>Valyuta:</span>
      <button :class="['nx-mode', { active: priceCurrency === 'dollar' }]" @click="priceCurrency = 'dollar'">Dollar $</button>
      <button :class="['nx-mode', { active: priceCurrency === 'som' }]" @click="priceCurrency = 'som'">So'm</button>
      <span class="nx-count">{{ items.length }} ta mahsulot</span>
    </div>

    <!-- PREVIEW (A4 sheet) -->
    <div class="nx-preview">
      <div class="nx-sheet" ref="sheet" v-html="bodyHtml"></div>
    </div>
  </div>
</template>

<script>
// Katalog dizayni va chop etish — umumiy modulda (Kirim/Mahsulotlar bo'limlari ham ishlatadi)
import { NX_CSS, buildNarxnomaBody, printNarxnoma } from './narxnomaPdf';

export default {
  name: 'Narxnoma',
  data() {
    const today = new Date();
    const first = new Date(today.getFullYear(), today.getMonth(), 1);
    return {
      date1: this.ds(first),
      date2: this.ds(today),
      brand_id: null,
      brandList: [],
      items: [],
      loading: false,
      priceMode: 'optom',
      priceCurrency: 'dollar',
    };
  },
  computed: {
    styleTag() { return `<style>${NX_CSS}</style>`; },
    bodyHtml() { return buildNarxnomaBody(this.items, this.priceMode, this.priceCurrency); },
  },
  mounted() {
    this.loadBrands();
    this.fetch();
  },
  methods: {
    ds(d) { return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; },
    toUnix(s, end = false) { return Math.floor(new Date(s + (end ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000); },
    loadBrands() {
      axios.get('api/v1/brand/').then(r => { this.brandList = r.data || []; }).catch(() => { this.brandList = []; });
    },
    fetch() {
      this.loading = true;
      axios.post('api/v1/report/narxnoma/', {
        datetime1: this.toUnix(this.date1),
        datetime2: this.toUnix(this.date2, true),
        brand_id: this.brand_id || null,
      }).then(r => {
        this.items = (r.data && r.data.items) || [];
      }).catch(() => {
        this.items = [];
      }).finally(() => {
        this.loading = false;
      });
    },
    printPdf(mode) {
      this.priceMode = mode; // preview ham mos bo'lsin
      if (!printNarxnoma(this.items, mode, this.priceCurrency)) {
        // popup bloklansa — sahifaning o'zini chop etamiz
        this.$nextTick(() => window.print());
      }
    },
  },
};
</script>

<style scoped>
.nx-page {
  padding: 16px;
  background: #e2e8f0;
  min-height: 100vh;
}

/* TOOLBAR */
.nx-toolbar {
  background: #fff;
  border-radius: 16px;
  padding: 12px 16px;
  display: flex;
  align-items: flex-end;
  gap: 16px;
  flex-wrap: wrap;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.05);
}
.nx-tool-left { display: flex; align-items: center; gap: 10px; }
.nx-back {
  width: 38px; height: 38px; border-radius: 10px; border: 1px solid #e2e8f0;
  background: #f8fafc; color: #475569; cursor: pointer;
}
.nx-title { margin: 0; font-size: 20px; font-weight: 800; color: #1e293b; }
.nx-filters { display: flex; gap: 12px; flex: 1; flex-wrap: wrap; }
.nx-f { display: flex; flex-direction: column; gap: 4px; }
.nx-f.nx-grow { flex: 1; min-width: 180px; }
.nx-f label { font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; }
.nx-f input {
  height: 38px; border: 1px solid #e2e8f0; border-radius: 10px; padding: 0 10px; outline: none;
}
.nx-actions { display: flex; gap: 8px; align-items: flex-end; }
.nx-btn {
  height: 40px; padding: 0 16px; border-radius: 10px; border: none; font-weight: 700; font-size: 13px;
  cursor: pointer; display: inline-flex; align-items: center; gap: 6px; color: #fff;
}
.nx-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.nx-refresh { background: #64748b; padding: 0 12px; }
.nx-optom { background: #2563eb; }
.nx-chakana { background: #16a34a; }
.spin { animation: spin 0.8s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }

/* MODE BAR */
.nx-mode-bar {
  display: flex; align-items: center; gap: 8px;
  margin: 12px auto 0; max-width: 794px; font-size: 13px; color: #475569;
}
.nx-mode {
  border: 1px solid #cbd5e1; background: #fff; color: #475569;
  padding: 4px 14px; border-radius: 8px; font-weight: 700; cursor: pointer;
}
.nx-mode.active { background: #1e293b; color: #fff; border-color: #1e293b; }
.nx-sep { color: #cbd5e1; }
.nx-count { margin-left: auto; color: #94a3b8; font-weight: 600; }

/* PREVIEW */
.nx-preview {
  margin: 14px auto 0;
  max-width: 794px;
}
.nx-preview .nx-sheet {
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

@media print {
  .no-print { display: none !important; }
  .nx-page { background: #fff; padding: 0; }
  .nx-preview { margin: 0; max-width: none; }
  .nx-preview .nx-sheet { box-shadow: none; border-radius: 0; }
  @page { size: A4; margin: 8mm; }
}
</style>
